import React from 'react';
import PropTypes from 'prop-types';
import { getHPLCOverviewByExperimentId } from './IORequests';
import DataSerie from '../../../helpers/Saxs/DataSerie';
import _ from 'lodash';
import { getDownloadHDF5FramesURL } from '../../../api/ispyb';

class SaxsHPLCSummaryDataContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dataSeries: [],
            experimentId: null,
            fetched: false,
            fetching: false,
            selectedFrames: []
        }

        this.getData = this.getData.bind(this);
        this.parse = this.parse.bind(this);
        this.selectFrame = this.selectFrame.bind(this);
        this.getYValueByDataSerie = this.getYValueByDataSerie.bind(this);
    }

    render() {
        if (this.props.experimentId && this.state.experimentId != this.props.experimentId) {
            this.getData();
        }
        return this.props.children(this.state.dataSeries, this.state.selectedFrames, this.selectFrame);
    }

    getData() {
        const onSuccess = (response) => {
            this.setState({
                dataSeries: this.parse(response.data),
                experimentId: this.props.experimentId ? this.props.experimentId : null,
                fetching: false,
                fetched: true,
                selectedFrames: []
            });
        }

        const onError = (error) => {
            debugger;
            this.setState({
                error: error,
                fetching: false,
                fetched: false
            });
        }

        getHPLCOverviewByExperimentId(this.props.token, this.props.proposal, this.props.experimentId, onSuccess, onError);
    }

    /** 
     * Parse data 
     */
    parse(data) {
        let xValues = [];
        if (data.I0) {
            for (let i = 0; i < data.I0.length; i++) { xValues[i] = i; };
        }

        let dataSerie1 = new DataSerie('I0', xValues, data.I0, '#0066CC', 'I0', false);
        let dataSerie2 = new DataSerie('sum_I', xValues, data.sum_I, '#00FF00', 'sum_I', false);
        let dataSerie3 = new DataSerie('Rg', xValues, data.Rg, '#21610B', 'Rg', false);
        let dataSerie4 = new DataSerie('Mass', xValues, data.mass, '#FF9900', 'Mass', false);

        let dataSerieError1 = new DataSerie('I0StdDev', [], [], '', '', true);
        let dataSerieError3 = new DataSerie('RgStdDev', [], [], '', '', true);
        let dataSerieError4 = new DataSerie('MassStdDev', [], [], '', '', true);


        let dataSerieError1Index = 0;
        let dataSerieError3Index = 0;
        let dataSerieError4Index = 0;

        for (let j1 = 0; j1 < data.I0.length; j1++) {
            if (dataSerieError1Index === 0) {
                dataSerieError1.pushPoint(Number(j1), Number(data.I0[0]) + Number(data.I0_Stdev[0]));
                dataSerieError1.pushPoint(Number(j1), Number(data.I0[0]) - Number(data.I0_Stdev[0]));
            } else {
                dataSerieError1.addPointByIndex(Number(j1), Number(data.I0[j1]) + Number(data.I0_Stdev[j1]), dataSerieError1Index)
                dataSerieError1.addPointByIndex(Number(j1), Number(data.I0[j1]) - Number(data.I0_Stdev[j1]), dataSerieError1.values.x.length - dataSerieError1Index);
            }
            dataSerieError1Index++;
        }

        for (let j2 = 0; j2 < data.Rg.length; j2++) {
            if (dataSerieError3Index === 0) {
                dataSerieError3.pushPoint(Number(j2), Number(data.Rg[0]) + Number(data.Rg_Stdev[0]));
                dataSerieError3.pushPoint(Number(j2), Number(data.Rg[0]) - Number(data.Rg_Stdev[0]));
            } else {
                dataSerieError3.addPointByIndex(Number(j2), Number(data.Rg[j2]) + Number(data.Rg_Stdev[j2]), dataSerieError3Index)
                dataSerieError3.addPointByIndex(Number(j2), Number(data.Rg[j2]) - Number(data.Rg_Stdev[j2]), dataSerieError3.values.x.length - dataSerieError3Index);
            }
            dataSerieError3Index++;
        }

        for (let j3 = 0; j3 < data.mass.length; j3++) {
            if (dataSerieError4Index === 0) {
                dataSerieError4.pushPoint(Number(j3), Number(data.mass[0]) + Number(data.mass_Stdev[0]));
                dataSerieError4.pushPoint(Number(j3), Number(data.mass[0]) - Number(data.mass_Stdev[0]));
            } else {
                dataSerieError4.addPointByIndex(Number(j3), Number(data.mass[j3]) + Number(data.mass_Stdev[j3]), dataSerieError4Index)
                dataSerieError4.addPointByIndex(Number(j3), Number(data.mass[j3]) - Number(data.mass_Stdev[j3]), dataSerieError4.values.x.length - dataSerieError4Index);
            }
            dataSerieError4Index++;
        }

        return [dataSerie1, dataSerie2, dataSerie3, dataSerie4, dataSerieError1, dataSerieError3, dataSerieError4];
    }


    selectFrame(frameId) {
        if (frameId) {
            let selectedFrames = _.cloneDeep(this.state.selectedFrames);  // an object with the following structure {frameId: xx; mass: xx, rg:..., I0:..., downloadURL: xx }


            let isFrameAlreadySelected = false;
            selectedFrames.forEach(selectedFrame => {
                if (selectedFrame.frameId === frameId) {
                    selectedFrame.isVisible = true; // the frame was already selected. Just need to make it visible
                    isFrameAlreadySelected = true;
                } else {
                    selectedFrame.isVisible = false;
                }
            });

            if (isFrameAlreadySelected === false) {
                selectedFrames.push({
                    frameId: frameId,
                    I0: this.getYValueByDataSerie('I0', frameId),
                    rg: this.getYValueByDataSerie('Rg', frameId),
                    mass: this.getYValueByDataSerie('Mass', frameId),
                    downloadUrl: getDownloadHDF5FramesURL(this.props.token, this.props.proposal, this.props.experimentId, frameId, frameId),
                    isVisible: true
                });
            }

            this.setState({ selectedFrames: selectedFrames });
        }
    }

    /**
     * Get the yValue by dataSerie. Return null if not found.
     * @param {*} name name of the data serie
     * @param {*} xValue xValue to get Yvalue from
     */
    getYValueByDataSerie(name, xValue) {
        let dataSerie = _.find(this.state.dataSeries, dataSerie => dataSerie.name === name);
        if (dataSerie) {
            let index = _.findIndex(dataSerie.values.x, x => x === xValue)
            if (index) {
                return dataSerie.values.y[index];
            }
        }
        return null;
    }
}

export default SaxsHPLCSummaryDataContainer;

SaxsHPLCSummaryDataContainer.proptypes = {
    /* Experiment identifier */
    experimentId: PropTypes.string,
    /* Ispyb authentication token */
    token: PropTypes.string,
    /* Proposal name*/
    proposal: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsHPLCSummaryDataContainer.js